export const squishArrayIntoColumns = (arr, cols) => {
    if (arr.length === 0) return [[]]
    const numRows = Math.ceil(arr.length / cols)
    var res = []
    for (var r = 0; r < numRows; r++) {
        res.push([])
        for (var c = 0; c < cols; c++) {
            if (r * cols + c >= arr.length) break
            res[r].push(arr[r * cols + c])
        }
    }
    return res
}

export const getSquishRows = (n) => {
    if (n <= 2) return 1
    if (n <= 6) return 2
    if (n <= 9) return 3
    return 4
}

export const getSortedPlayersByGain = (gameObjects) => {
    var res = [gameObjects.curPlayer]
    for(let i = 0; i < gameObjects.otherPlayers.length; i++){
        res.push(gameObjects.otherPlayers[i])
    }
    res.sort((a, b) => {return b.scoreGain - a.scoreGain})
    return res
}

export function capitalize(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }